import { Backend, backendBasePath } from './backend';

export interface Landmark {
  rotate: number;
  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
  color: string;
  type: string; // TODO complete
  opacity: number;
}

export interface Blueprint {
  show: boolean;
  src: string;
  x: number;
  y: number;
  width: number;
  height: number;
  opacity: number;
  ratio: number;
}

export interface Seat {
  id: number;
  ranking: number;
  no: string;
  info?: string;
  variant_id: number;
  name: string;
  x: number;
  y: number;
}

export interface VariantColors {
  [variantId: string]: string;
}

export interface SeatRow {
  name: string;
  seats: Seat[];
}

export interface SeatBlock {
  id: number;
  name: string;
  x: number;
  y: number;
  width: number;
  height: number;
  rotate: number;
  variant_id: number;
  hull: string;
  arc?: number;
  arc_rotation_anchor?: number;
  opacity: number;
  text_size?: number;
  text_color?: string;
  text_rotation: number;
  type: 'seatblock' | 'freeformseatblock' | string; // TODO complete
  color: string;
  rows: SeatRow[];
}

export interface SeatingPlan {
  id: number;
  name: string;
  width: number;
  height: number;
  seatwidth: number;
  opt_x: number;
  opt_y: number;
  stage_x: number;
  stage_y: number;
  landmarks: Landmark[];
  blueprint: Blueprint;
  blocks: SeatBlock[];
}

export interface DeflatedSeatStatuses {
  /**
   * Timestamp of the last request
   */
  time: number;
  free: (number | number[])[];
  handicap: (number | number[])[];
  channeled: (number | number[])[];
  mine: (number | number[])[];
  blocked: (number | number[])[];
}

export const SeatStatus = {
  free: 0b00001,
  mine: 0b00010,
  handicap: 0b00100,
  channeled: 0b01000,
  pending: 0b10000,
};

export type SeatStatuses = number[];

export function inflateSeats(deflatedSeats: DeflatedSeatStatuses): SeatStatuses {
  // TODO these need to be handled and not just removed...
  const copy = {
    free: deflatedSeats.free,
    handicap: deflatedSeats.handicap,
    channeled: deflatedSeats.channeled,
    mine: deflatedSeats.mine,
  };

  return Object.keys(copy).reduce((inflatedSeats, key: keyof Omit<DeflatedSeatStatuses, 'time' | 'blocked'>) => {
    return copy[key].reduce((acc, seatRange) => {
      if (Array.isArray(seatRange)) {
        // inflate ranges
        for (let i = seatRange[0]; i <= seatRange[1]; i += 1) {
          acc[i] = (acc[i] || 0) | SeatStatus[key]; // bitwise combination
        }
      } else if (!isNaN(seatRange)) {
        acc[seatRange] = (acc[seatRange] || 0) | SeatStatus[key]; // bitwise combination
      }
      return acc;
    }, inflatedSeats);
  }, []);
}

export async function getSeatingPlanForProductId(productId: number, options?: RequestInit) {
  return Backend.get<SeatingPlan>(`/catalog/products/${encodeURIComponent(productId)}/seating_plan`, options);
}

export async function getSeatStatusesForProductId(productId: number, options?: RequestInit) {
  const seatStatuses = await Backend.get<DeflatedSeatStatuses>(
    `/catalog/products/${encodeURIComponent(productId)}/seating_plan/seats_status`,
    options
  );
  return inflateSeats(seatStatuses);
}

export function createSeatingPlanCSSPath(productId: number) {
  return `${backendBasePath}/catalog/products/${encodeURIComponent(productId)}/seating_plan.css`;
}

export function createSeatingPlanPreviewPath(productId: number) {
  return `${backendBasePath}/catalog/products/${encodeURIComponent(productId)}/seating_plan.png`;
}
